import React, { FC } from "react";
import styles from "./Logo.module.scss";
import Image from "next/image";

const Logo: FC = () => {
  return (
    <div className={styles.logo}>
      <Image
        src="/logoJM.png"
        alt="logo"
        fill
        priority
        sizes="(max-width: 768px) 100vw, 200px"
      />
    </div>
  );
};

export default Logo;
